<template>
<v-container fluid>
    <v-dialog v-model="dialog" max-width="500px">
        <v-btn slot="activator" color="primary" dark class="mb-2" @click="addEntry">New Route</v-btn>
        <v-card>
            <v-card-title>
                <span class="headline">Edit Route</span>
            </v-card-title>
            <v-card-text>
                <v-form v-model="valid" lazyValidation>

                    <v-container grid-list-md>
                        <v-layout row wrap>

                            <v-flex xs4>
                                <v-text-field v-model="editedItem.id" label="Route ID" v-validate="'required'" name="id" :error-messages="errors.collect('id')"></v-text-field>
                            </v-flex>

                            <v-flex xs6>
                                <v-text-field name="path" v-model="editedItem.path" label="Path" v-validate="'required'" :error-messages="errors.collect('path')"></v-text-field>
                            </v-flex>
                            <v-flex xs12>
                                <v-text-field name="reportLabel" v-model="editedItem.reportLabel" label="Report Label" v-validate="'required'" :error-messages="errors.collect('reportLabel')"></v-text-field>
                            </v-flex>
                            <v-flex xs12>
                                <v-text-field name="name" v-model="editedItem.name" label="Name" v-validate="'required'" :error-messages="errors.collect('name')"></v-text-field>
                            </v-flex>
                            <v-flex xs12>
                                <v-text-field name="component" v-model="editedItem.component" label="Component" v-validate="'required'" :error-messages="errors.collect('component')"></v-text-field>
                            </v-flex>

                            <v-flex xs12>
                                <v-text-field name="beforeEnter" v-model="editedItem.beforeEnter" label="Before Enter" v-validate="''" :error-messages="errors.collect('beforeEnter')"></v-text-field>
                            </v-flex>
                            <v-flex xs12>
                                <v-text-field name="icon" v-model="editedItem.beforeEnter" label="Icon" v-validate="''" :error-messages="errors.collect('icon')"></v-text-field>
                            </v-flex>
                        </v-layout>
                    </v-container>
                </v-form>
                <message-alert :component="message"></message-alert>
            </v-card-text>
            <v-card-actions>
                <v-spacer></v-spacer>
                 <v-btn color="primary" @click.native="save">Save</v-btn>
                  <v-btn color="light-grey" @click.native="close">Cancel</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>

    <div>
        <v-layout row>
            <v-flex xs4>
                <v-text-field name="Search" label="Search" v-model="SearchText" append-icon="search"></v-text-field>
            </v-flex>

        </v-layout>
    </div>

    <v-data-table :total-items="totalItems" :pagination.sync="pagination" :items="filteredRows" :headers="headers" :loading="loading">

        <template slot="items" slot-scope="props">
            <td v-for="(prop,propIndex) in headers" :key="propIndex" :class="'ma-0'">
                <div v-if="prop.autocomplete" :class="'text-xs-' +prop.align">
                    {{props.item[prop.value][prop.nested]}}
                </div>

                <div v-else :class="'text-xs-' + prop.align">
                    {{formatProp( { item: props.item, value: prop.value})}}
                </div>

            </td>

            <td class="justify-center layout px-0">
                <v-btn icon class="mx-0" @click="editItem(props.item)">
                    <v-icon color="teal">edit</v-icon>
                </v-btn>
                <v-btn icon class="mx-0" @click="deleteItem(props.item)">
                    <v-icon color="pink">delete</v-icon>
                </v-btn>
            </td>
        </template>

    </v-data-table>
    <v-flex sm12 md12 lg12>
        <message-alert :component="message"></message-alert>
    </v-flex>
</v-container>
</template>

<script>
import { mapActions, createNamespacedHelpers } from "vuex";
import { mapMultiRowFields } from "vuex-map-fields";
import {
  mapVueRoutesFields,
  mapVueRoutesMultiRowFields
} from "@/store/modules/orders";

const {
  mapActions: mapVueRoutesActions,
  mapMutations: mapVueRoutesMutations
} = createNamespacedHelpers(`orders/routes`);
import { httpError } from "@/models/httpError";
import { Term } from "@/models/term";

export default {
  name: "maintainTerms",
  data: () => ({
    valid: true,
    dialog: false,
    editedItem: new Term(),
    editedIndex: 0,
    SearchText: null,
    items: [],
    totalItems: 0,
    pagination: {
      page: 1,
      rowsPerPage: 20,
      totalItems: 0
    },
    loading: false,
    headers: [
      {
        text: "Route ID",
        align: "right",
        sortable: true,
        value: "id"
      },

      {
        text: "Path",
        align: "left",
        sortable: true,
        value: "path"
      },
      {
        text: "Report Label",
        align: "left",
        sortable: true,
        value: "reportLabel"
      },
      {
        text: "Name",
        align: "left",
        sortable: true,
        value: "name"
      },
      {
        text: "Component",
        align: "left",
        sortable: true,
        value: "component"
      },
      {
        text: "Icon",
        align: "left",
        sortable: false,
        value: "icon"
      }
    ]
  }),

  computed: {
    ...mapVueRoutesFields(["message"]),
    ...mapVueRoutesMultiRowFields(["rows"]),
    filteredRows: function() {
      let vm = this;
      return vm.rows.filter(this.isValid);
    }
  },
  methods: {
    ...mapVueRoutesActions([
      "getRoutes",
      "updateRoute",
      "setMessage",
      "removeRoute"
    ]),
    ...mapVueRoutesMutations(["addRow"]),
    addEntry() {
      this.setMessage(new httpError());
      this.editedIndex = this.addRow();
      this.editedItem = this.rows[editedIndex];
    },
    formatProp(el) {
      if (el.item.abstract) {
        return el.item[el.value].toString().substring(0, el.item.abstract);
      } else {
        return el.item[el.value];
      }
    },
    getDataFromApi() {
      let vm = this;
      this.loading = true;
      return new Promise((resolve, reject) => {
        vm.getRoutes().then(data => {
          let items = data.data;
          const total = data.count;
          vm.loading = false;
          resolve({
            items,
            total
          });
        });
      });
    },

    editItem(item) {
      this.setMessage(new httpError());
      this.editedIndex = this.rows.indexOf(item);
      this.editedItem = this.rows[this.editedIndex];
      this.dialog = true;
    },

    deleteItem(item) {
      let vm = this;
      this.setMessage(new httpError());
      const index = this.rows.indexOf(item);
      let answer = confirm("Are you sure you want to delete this item?");
      if (answer) {
        vm.removeRoute(vm.rows[index].id).then(data => {
          //this.items.splice(index, 1);
        });
      }
    },

    isValid: function(item) {
      let vm = this;
      if (vm.SearchText === null) return true;
      const filters = vm.headers.filter(x => x.sortable).map(x => x.value);

      for (var i = 0; i < filters.length; i++) {
        if (item[filters[i]] !== null) {
          if (
            item[filters[i]]
              .toString()
              .toUpperCase()
              .includes(vm.SearchText.toUpperCase())
          )
            return true;
        }
      }
    },

    close() {
      this.dialog = false;
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      }, 300);
    },

    save() {
      let vm = this;
      vm.$validator.validateAll().then(async result => {
        if (result) {
          vm
            .updateRoute(this.editedIndex)
            .then(() => this.close())
            .catch(() => this.close());
        }
      });
    }
  },
  mounted() {
    let vm = this;
    this.$nextTick(() => {
      vm.getDataFromApi();
    });
  }
};
</script>
